import type { ReactNode } from 'react'
import styles from './KpiCard.module.css'

interface KpiCardProps {
  label: ReactNode
  value: ReactNode
  meta?: ReactNode
  indicator?: 'default' | 'positive' | 'critical' | 'none'
  size?: 'default' | 'compact' | 'dense'
  className?: string
}

export function KpiCard({
  label,
  value,
  meta,
  indicator = 'default',
  size = 'default',
  className,
}: KpiCardProps) {
  const isCompact = size === 'compact'
  const isDense = size === 'dense'
  const cardClassName = [
    styles.card,
    isCompact ? styles.cardCompact : '',
    isDense ? styles.cardDense : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')
  const headerClassName = [
    styles.header,
    isDense ? styles.headerDense : '',
  ]
    .filter(Boolean)
    .join(' ')
  const valueRowClassName = [
    styles.valueRow,
    isDense ? styles.valueRowDense : '',
  ]
    .filter(Boolean)
    .join(' ')
  const indicatorClassName = [
    styles.indicator,
    indicator === 'positive' ? styles.indicatorPositive : '',
    indicator === 'critical' ? styles.indicatorCritical : '',
    isDense ? styles.indicatorDense : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <article className={cardClassName}>
      <div className={headerClassName}>
        <span className={`microlabel ${styles.label} ${isCompact ? styles.labelCompact : ''} ${isDense ? styles.labelDense : ''}`}>{label}</span>
        {indicator !== 'none' && <span className={indicatorClassName} aria-hidden="true" />}
      </div>
      <div className={valueRowClassName}>
        <strong className={`${styles.value} ${isCompact ? styles.valueCompact : ''} ${isDense ? styles.valueDense : ''}`}>{value}</strong>
      </div>
      {meta ? <small className={`${styles.meta} ${isCompact ? styles.metaCompact : ''} ${isDense ? styles.metaDense : ''}`}>{meta}</small> : null}
    </article>
  )
}
